var _style, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgEmptyGradebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 186.1",
    enableBackground: "new 0 0 350 186.1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".style0{fill:\t#424242;}.style1{fill:\t#FFFFFF;}.style10{fill:\t#E4F9F2;}.style11{fill:\t#B5EEDC;}.style12{fill:\t#5DD9A9;}.style13{fill:\t#E3F4FD;}.style14{fill:\t#C9DDEA;}.style15{fill:\t#F3FAFE;}.style16{fill:\t#AFC6D6;}.style17{fill:\t#15729A;}.style18{fill:\t#FE6619;}.style19{fill:\t#04D6FF;}.style2{fill:\t#E5E5E5;}.style20{fill:\t#FEDF1E;}.style21{fill:\t#C672D4;}.style22{fill:\t#858585;}.style3{fill:\t#C472D3;}.style4{fill:\t#8848B4;}.style5{fill:\t#448EAE;}.style6{fill:\t#95BFD1;}.style7{fill:\t#D2ECFA;}.style8{fill:\t#2DCF9A;}.style9{fill:\t#04BA86;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M323.5 148.8c0-11.4-68.8-20.6-153.8-20.6s-153.8 9.2-153.8 20.6c0 0 0 0 0 0L323.5 148.8 C323.5 148.8 323.5 148.8 323.5 148.8z",
    className: "style0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M114.8 130.7c-4.8 0-8.8-3.9-8.8-8.8L105.7 12c0-4.8 3.9-8.8 8.8-8.8l110.1-0.3c4.8 0 8.8 3.9 8.8 8.8 l0.3 109.9c0 4.8-3.9 8.8-8.8 8.8L114.8 130.7z",
    className: "style1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.1 142.6l52.8-0.1c4.8 0 8.8-4 8.8-8.8l-0.1-64.8l-61.6 0.1L172.1 142.6z",
    className: "style2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.1 121.9l52.8-0.1c4.8 0 8.8-4 8.8-8.8l-0.1-44l-61.6 0.1L172.1 121.9z",
    className: "style1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.4 3l-52.8 0.1c-4.8 0-8.8 4-8.8 8.8l0.1 52.8l61.6-0.1L167.4 3z",
    className: "style3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9 69.2L106 134c0 4.8 4 8.8 8.8 8.8l52.8-0.1l-0.1-73.6L105.9 69.2z",
    className: "style4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9 69.2l0.1 44c0 4.8 4 8.8 8.8 8.8l52.8-0.1l-0.1-52.8L105.9 69.2z",
    className: "style3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.6 2.9L171.8 3l0.1 61.6l61.6-0.1l-0.1-52.8C233.4 6.8 229.4 2.9 224.6 2.9z",
    className: "style3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.4,
    y: 33.9,
    transform: "matrix(-1 2.411514e-03 -2.411514e-03 -1 277.7426 71.919)",
    width: 30.8,
    height: 4.4,
    className: "style1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.1,
    y: 33.8,
    transform: "matrix(-1 2.411514e-03 -2.411514e-03 -1 401.0196 71.4731)",
    width: 30.8,
    height: 4.4,
    className: "style1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.2,
    y: 91,
    transform: "matrix(-1 2.411514e-03 -2.411514e-03 -1 401.4337 185.9446)",
    width: 30.8,
    height: 4.4,
    className: "style3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.2,
    y: 99.8,
    transform: "matrix(-1 2.411514e-03 -2.411514e-03 -1 401.4973 203.5556)",
    width: 30.8,
    height: 4.4,
    className: "style3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.6,
    y: 20.7,
    transform: "matrix(-1 2.411514e-03 -2.411514e-03 -1 277.7426 71.919)",
    width: 4.4,
    height: 30.8,
    className: "style1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.6,
    y: 95.6,
    transform: "matrix(-0.7088 -0.7054 0.7054 -0.7088 168.5224 265.0951)",
    width: 30.8,
    height: 4.4,
    className: "style1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.8,
    y: 82.4,
    transform: "matrix(-0.7088 -0.7054 0.7054 -0.7088 168.5224 265.0951)",
    width: 4.4,
    height: 30.8,
    className: "style1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.5,
    y1: 147,
    x2: 305.5,
    y2: 149.9,
    className: "style5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.7,149.7 216.8,147 255.1,32.9 335.7,59.9 306.5,147",
    className: "style5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.5,146.6 246.1,37.3 326.7,64.4 299.3,146.3",
    className: "style6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.7 149.4l65.9 0.5",
    className: "style7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.6 149.9l15.9-47.5l-24.6-15.7l2.3-29.1L243.9 44c-3.7-1.2-7.7 0.8-9 4.5l-33.8 100.7l23.5 0.2",
    className: "style7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.2 57.6l-3.4-1.1L243.9 44l1.1-3.4L282 53.1l3.4 1.1l0 0c1.8 0.6 3.2 1.9 4.1 3.6l20.1 40.4 c0.8 1.7 1 3.6 0.4 5.4l-1.1 3.4l-14.7 43.7l-72.8-22.4L243.9 44",
    className: "style1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.2 57.6c0.9 0.3 1.6 0.9 2 1.8l20.1 40.4c0.4 0.8 0.5 1.8 0.2 2.7l-1.1 3.4l-14.8 44.2",
    className: "style1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298,149.9 327.9,61 331.2,62.1 301.8,149.9",
    className: "style1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.4,
    y: 48.5,
    transform: "matrix(-0.9481 -0.3181 0.3181 -0.9481 549.6526 190.3421)",
    width: 77.9,
    height: 3.5,
    className: "style1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6 148.6L7.8 52.5c-1-3.6 1.1-7.4 4.8-8.5l52.9-14.8l14 24.6l28.3-0.8l26.1 92.1c0.3 1.2 0.3 2.5 0 3.7",
    className: "style8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7 148.6L7.8 52.5c-1-3.6 1.1-7.4 4.8-8.5l52.9-14.8l14 24.6l28.3-0.8l22.2 79.3c1 3.6-1.1 7.4-4.8 8.5 l-30 8.4L34.7 148.6z",
    className: "style8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7 56.4c-0.2-0.9-0.8-1.6-1.6-2.1L69 32.9c-0.8-0.4-1.7-0.6-2.6-0.3l-3.3 0.9l8.3 29.7 c1 3.6 4.8 5.8 8.4 4.8l29.8-8.3L108.7 56.4z",
    className: "style9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.7 53.1c-0.2-0.9-0.8-1.6-1.6-2.1L68.1 29.6c-0.8-0.4-1.7-0.6-2.6-0.3l-3.3 0.9L70.5 60 c1 3.6 4.8 5.8 8.4 4.8l29.8-8.3L107.7 53.1z",
    className: "style10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.3,
    y: 81.2,
    transform: "matrix(-0.9631 0.2693 -0.2693 -0.9631 187.2416 140.1444)",
    width: 27.5,
    height: 3.4,
    className: "style11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 93,
    transform: "matrix(-0.9631 0.2693 -0.2693 -0.9631 182.8755 164.2738)",
    width: 13.7,
    height: 3.4,
    className: "style11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1 94.7l1.8 6.6l-6.6 1.8l-1.8-6.6L48.1 94.7 M50.5 90.5l-13.2 3.7l3.7 13.2l13.2-3.7L50.5 90.5 L50.5 90.5z",
    className: "style11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.4,
    y: 87.5,
    transform: "matrix(-0.9631 0.2693 -0.2693 -0.9631 147.6184 168.4369)",
    width: 13.7,
    height: 13.7,
    className: "style12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.8,
    y: 101,
    transform: "matrix(-0.9631 0.2693 -0.2693 -0.9631 203.4694 177.5845)",
    width: 27.5,
    height: 3.4,
    className: "style11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.9,
    y: 112.8,
    transform: "matrix(-0.9631 0.2693 -0.2693 -0.9631 199.1033 201.7139)",
    width: 13.7,
    height: 3.4,
    className: "style11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2 109.9l1.8 6.6l-6.6 1.8l-1.8-6.6L70.2 109.9 M72.6 105.7l-13.2 3.7l3.7 13.2l13.2-3.7L72.6 105.7 L72.6 105.7z",
    className: "style11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.4,
    y: 111.9,
    transform: "matrix(-0.9631 0.2693 -0.2693 -0.9631 132.6461 219.4003)",
    width: 13.7,
    height: 13.7,
    className: "style12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4,
    y: 120.9,
    transform: "matrix(-0.9631 0.2693 -0.2693 -0.9631 219.6973 215.0247)",
    width: 27.5,
    height: 3.4,
    className: "style11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.4,
    y: 132.6,
    transform: "matrix(-0.9631 0.2693 -0.2693 -0.9631 215.3312 239.1541)",
    width: 13.7,
    height: 3.4,
    className: "style11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2 134.4L61 141l-6.6 1.8l-1.8-6.6L59.2 134.4 M61.6 130.2l-13.2 3.7l3.7 13.2l13.2-3.7L61.6 130.2 L61.6 130.2z",
    className: "style11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 127.1,
    transform: "matrix(-0.9631 0.2693 -0.2693 -0.9631 180.0741 243.3172)",
    width: 13.7,
    height: 13.7,
    className: "style12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.3 148.8c-1.2-1.8-1.6-4.1-0.9-6.3l31.5-94c1.2-3.7 5.3-5.7 9-4.5l40.3 13.5l-2.3 29.1l24.6 15.7 l-15.6 46.5L204.3 148.8z",
    className: "style13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.4 105.8c0.3-0.9 0.2-1.9-0.2-2.7l-20.1-40.4c-0.4-0.8-1.2-1.5-2-1.8l-3.4-1.1L269.6 90 c-1.2 3.7 0.8 7.7 4.4 9l30.2 10.1L305.4 105.8z",
    className: "style14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.5 102.4c0.3-0.9 0.2-1.9-0.2-2.7l-20.1-40.4c-0.4-0.8-1.2-1.5-2-1.8l-3.4-1.1l-10.1 30.2 c-1.2 3.7 0.8 7.7 4.4 9l30.2 10.1L306.5 102.4z",
    className: "style15"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.6,149.9 224.7,145.9 225.8,142.6 246.6,149.5",
    className: "style16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.5,
    y: 139.2,
    transform: "matrix(-0.9481 -0.3181 0.3181 -0.9481 439.7422 353.6832)",
    width: 42.5,
    height: 3.5,
    className: "style16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.9,
    y: 129.1,
    transform: "matrix(-0.9481 -0.3181 0.3181 -0.9481 449.5309 335.1336)",
    width: 42.5,
    height: 3.5,
    className: "style16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.8,
    y: 117.8,
    transform: "matrix(-0.335 0.9422 -0.9422 -0.335 463.9652 -88.3811)",
    width: 14.8,
    height: 3.5,
    className: "style17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.5,
    y: 121.3,
    transform: "matrix(-0.335 0.9422 -0.9422 -0.335 474.4636 -88.7902)",
    width: 12,
    height: 3.5,
    className: "style18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.9,
    y: 120.7,
    transform: "matrix(-0.335 0.9422 -0.9422 -0.335 482.6978 -95.7853)",
    width: 16.4,
    height: 3.5,
    className: "style19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.3,
    y: 62.3,
    transform: "matrix(-0.9481 -0.3181 0.3181 -0.9481 474.3842 205.6144)",
    width: 21.3,
    height: 3.5,
    className: "style16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.4,
    y: 67.3,
    transform: "matrix(-0.9481 -0.3181 0.3181 -0.9481 457.831 212.994)",
    width: 9.9,
    height: 3.5,
    className: "style16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.7 96.6c-1-0.4-2-0.6-3.1-0.6c-3.6 0-6.7 2.2-8 5.3l8 3.4L249.7 96.6z",
    className: "style17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.6 101.3c-0.5 1.1-0.7 2.2-0.7 3.4c0 3.7 2.3 6.9 5.6 8.1l3.1-8.2L238.6 101.3z",
    className: "style19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.6 104.7l7.7-4.1c-1-1.9-2.7-3.4-4.7-4.1L246.6 104.7L246.6 104.7z",
    className: "style18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.6 112.9l-2.9-8.2l0 0l-3.1 8.2c1 0.4 2 0.6 3.1 0.6C247.7 113.5 248.6 113.3 249.6 112.9z",
    className: "style20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.6 112.9c3.4-1.2 5.8-4.4 5.8-8.2c0-1.5-0.4-2.8-1-4.1l-7.7 4.1L249.6 112.9z",
    className: "style21"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 18.1,
    y1: 148.8,
    x2: 321.3,
    y2: 148.8,
    className: "style1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.3 151H18.1c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2h303.1c1.2 0 2.2 1 2.2 2.2S322.5 151 321.3 151z",
    className: "style22"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 169.7,
    cy: 148.8,
    r: 31.8,
    className: "style1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M169.7 182.8c-18.7 0-34-15.3-34-34c0-18.7 15.3-34 34-34s34 15.3 34 34 C203.7 167.5 188.5 182.8 169.7 182.8z M169.7 119.2c-16.3 0-29.6 13.3-29.6 29.6c0 16.3 13.3 29.6 29.6 29.6 s29.6-13.3 29.6-29.6C199.3 132.5 186 119.2 169.7 119.2z",
    className: "style22"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 153.2,
    y1: 148.8,
    x2: 186.2,
    y2: 148.8,
    className: "style1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.2 151h-33c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2h33c1.2 0 2.2 1 2.2 2.2S187.4 151 186.2 151z",
    className: "style22"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 169.7,
    y1: 132.3,
    x2: 169.7,
    y2: 165.3,
    className: "style1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.7 167.5c-1.2 0-2.2-1-2.2-2.2v-33c0-1.2 1-2.2 2.2-2.2s2.2 1 2.2 2.2v33 C171.9 166.5 170.9 167.5 169.7 167.5z",
    className: "style22"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgEmptyGradebook);
export default __webpack_public_path__ + "static/media/svg-empty-gradebook.5499e70f19580f0adfea0bdc7d83f0ac.svg";
export { ForwardRef as ReactComponent };